function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: 24,
  width: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14,9.1h-4c-0.55,0-1-0.45-1-1l0,0c0-0.55,0.45-1,1-1h4c0.55,0,1,0.45,1,1l0,0C15,8.65,14.55,9.1,14,9.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,12.1h-4c-0.55,0-1-0.45-1-1l0,0c0-0.55,0.45-1,1-1h4c0.55,0,1,0.45,1,1l0,0C15,11.65,14.55,12.1,14,12.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5,3.6l-1.15-1.15c-0.2-0.2-0.51-0.2-0.71,0L16.5,3.6l-1.15-1.15c-0.2-0.2-0.51-0.2-0.71,0L13.5,3.6l-1.15-1.15 c-0.2-0.2-0.51-0.2-0.71,0L10.5,3.6L9.35,2.46c-0.2-0.2-0.51-0.2-0.71,0L7.5,3.6L6.43,2.53C6.27,2.37,6,2.48,6,2.71v13.4H4 c-0.55,0-1,0.45-1,1v2c0,1.66,1.34,3,3,3h12c1.66,0,3-1.34,3-3V2.71c0-0.22-0.27-0.33-0.43-0.18L19.5,3.6z M19,19.1 c0,0.55-0.45,1-1,1s-1-0.45-1-1v-2c0-0.55-0.45-1-1-1h-2h-2H8v-11h11V19.1z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 8.1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 11.1,
  r: 1
}))));

var SvgTopics = function SvgTopics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/topics.6b39a927.svg";
export { ForwardRef as ReactComponent };